import { Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { appSettings } from '../../../config';
import { FreebieEntity } from './freebies/entity/freebie.entity';
import { ScheduleModule } from '@nestjs/schedule';
import { TypeOrmModule } from '@nestjs/typeorm';
import { FreebiesModule } from './freebies/freebies.module';
import { DeviceEntity } from './devices/entity/device.entity';
import { DeviceGroupEntity } from './devices/entity/devicegroup.entity';
import { RfCodesEntity } from './devices/entity/rf-codes.entity';
import { EmployeeFreebiesEntity } from './tokens/entity/employee-freebies.entity';
import { FreebiesConsumptionEntity } from './tokens/entity/freebies-consumption.entity';
import { TokensModule } from './tokens/tokens.module';
import { DevicesModule } from './devices/devices.module';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
      // host: '206.189.138.212',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.cms_db,
      entities: [FreebieEntity,DeviceEntity,DeviceGroupEntity,RfCodesEntity,EmployeeFreebiesEntity,FreebiesConsumptionEntity],
      synchronize: false,
      logging: true
    }),
    FreebiesModule,TokensModule,DevicesModule ],
  controllers: [AppController],
  providers: [AppService,ApplicationExceptionHandler],
})
export class AppModule {}
